import React from 'react';
import './Page.css'
const Page = () => {
    return (
        <div className="page">
            <img src="https://i2.wp.com/learn.onemonth.com/wp-content/uploads/2017/08/1-10.png?fit=845%2C503&ssl=1" alt="" />
        </div>
    );
};

export default Page;